"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { AuthMethod, OAuthMethod } from "@getpara/web-sdk";
import { useModalStore, useThemeStore, useUserInfoStore } from "../../stores/index.js";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { HeroSpinner } from "@getpara/react-common";
import { ModalStep } from "../../utils/steps.js";
import { CpslSpinner } from "@getpara/react-components";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
import { useSetLoginURLs } from "../../hooks/useSetLoginURLs.js";
function TelegramOAuthStep() {
  const iframe = useRef();
  const para = useInternalClient();
  const setFlow = useModalStore((state) => state.setFlow);
  const setStep = useModalStore((state) => state.setStep);
  const setAuthInfo = useUserInfoStore((state) => state.setAuthInfo);
  const setBiometricLocationHints = useModalStore((state) => state.setBiometricLocationHints);
  const setIFrameUrl = useModalStore((state) => state.setIFrameUrl);
  const setIsIFrameReady = useModalStore((state) => state.setIsIFrameReady);
  const setAuthStepRoute = useModalStore((state) => state.setAuthStepRoute);
  const setWebAuthURLForCreate = useModalStore((state) => state.setWebAuthURLForCreate);
  const theme = useThemeStore((state) => state.theme);
  const setLoginURLs = useSetLoginURLs();
  const [url, setUrl] = useState(void 0);
  const [isWaiting, setIsWaiting] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (!url) {
      para.getOAuthURL({ method: OAuthMethod.TELEGRAM }).then((url2) => {
        setUrl(url2);
      });
    }
  }, [url]);
  useEffect(() => {
    const updateState = (event) => __async(this, null, function* () {
      switch (event.data.type) {
        case "TELEGRAM_LOGIN":
          setIsWaiting(true);
          setIsError(false);
          break;
        case "TELEGRAM_FAILED":
          setIsWaiting(false);
          setIsError(true);
          break;
        case "TELEGRAM_SUCCESS":
          if (!!event.data.payload) {
            const authObject = event.data.payload;
            const result = yield para.verifyTelegram(authObject);
            if (!result.isValid) {
              setIsWaiting(false);
              setIsError(true);
              iframe.current && iframe.current.contentWindow.postMessage({ type: "TELEGRAM_FAILED" }, "*");
              return;
            }
            const { telegramUserId, isNewUser, supportedAuthMethods, biometricHints } = result;
            const pfpUrl = authObject.photo_url;
            const displayName = authObject.username ? `@${authObject.username}` : authObject.first_name ? `${authObject.first_name}${authObject.last_name ? ` ${authObject.last_name}` : ""}` : `Telegram User @${telegramUserId}`;
            setAuthInfo({
              telegramUserId,
              pfpUrl,
              displayName
            });
            if (isNewUser) {
              const supportedCreateAuthMethods = yield para.getSupportedCreateAuthMethods();
              setIsIFrameReady(false);
              setFlow("signUp");
              const supportsPasskey = supportedCreateAuthMethods.has(AuthMethod.PASSKEY);
              if (supportsPasskey) {
                setWebAuthURLForCreate(
                  yield para.shortenLoginLink(yield para.getSetUpBiometricsURL({ authType: "telegram" }))
                );
                setStep(ModalStep.BIOMETRIC_CREATION);
              }
              if (supportedCreateAuthMethods.has(AuthMethod.PASSWORD)) {
                setIFrameUrl(yield para.shortenLoginLink(yield para.getSetupPasswordURL({ authType: "telegram", theme })));
                setAuthStepRoute(supportsPasskey ? ModalStep.BIOMETRIC_CREATION : ModalStep.PASSWORD_CREATION);
              }
            } else {
              setFlow("login");
              const supportedAuthMethodsSet = new Set(supportedAuthMethods);
              biometricHints && setBiometricLocationHints(biometricHints);
              yield setLoginURLs({
                supportedAuthMethods: supportedAuthMethodsSet,
                authType: "telegram",
                displayName,
                pfpUrl
              });
              setStep(ModalStep.BIOMETRIC_LOGIN);
            }
          }
          break;
      }
    });
    window == null ? void 0 : window.addEventListener("message", updateState, false);
    return () => {
      window == null ? void 0 : window.removeEventListener("message", updateState, false);
    };
  }, []);
  return /* @__PURE__ */ jsxs(Container, { children: [
    /* @__PURE__ */ jsx(HeroContainer, { children: /* @__PURE__ */ jsx(
      HeroSpinner,
      {
        icon: "telegramBrand",
        status: isWaiting ? "loading" : isError ? "error" : "inactive",
        text: isWaiting ? "Follow the on-screen prompts." : isError ? "Login Failed" : void 0
      }
    ) }),
    url && /* @__PURE__ */ jsx(IFrame, { ref: iframe, style: { display: isLoaded ? "block" : "none" }, src: url, onLoad: () => setIsLoaded(true) }),
    (!url || !isLoaded) && /* @__PURE__ */ jsx(CpslSpinner, {})
  ] });
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const HeroContainer = styled.div`
  display: flex;
  min-height: 276px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1;
`;
const IFrame = styled.iframe`
  width: 100%;
  height: 52px;
  border: none;
`;
export {
  TelegramOAuthStep
};
